<template>
  <div id="overlay">
    <div id="content">
      <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
        {{ message }}
      </div>
      <div class="row row-margin">
        <div class="col-12">
          <button class="btn btn-sm btn-outline-info modal-close" v-on:click="closeModal">キャンセルする</button>
        </div>
      </div>
      <div id="title" class="row">
        <div class="col-12 text-center">
          <h4>最新のユーザーを共通連絡先に反映する</h4>
        </div>
      </div>
      <div class="empty-row"></div>
      <div class="row">
        <div class="col-1" style="white-space: nowrap;">
          <b-button v-b-toggle.collapse-1 variant="btn btn-outline-primary">
            <span id="Arrow" v-bind:class="actionToggle" style="display:inline-block;"></span>説明
          </b-button>
        </div>
        <div class="d-flex align-items-end ml-4" v-if="this.$store.state.excludedUserData.length > 0">
          <h6 class="text-left">
            反映時に削除されるユーザーがいます。<br>「共通連絡先の対象から外す」設定されている下記ユーザーが削除対象です。
          </h6>
        </div>
         <div class="d-flex align-items-end ml-4" v-else>
          <h6 class="text-left">
            「共通連絡先の対象から外す」設定されているユーザーは削除対象となります。
          </h6>
        </div>
      </div>
      <div class="w-100">
        <b-collapse v-model="visible" id="collapse-1">
          <b-card class="custom-card">
            <div class="row">
              <div class="col-12" v-if="this.$store.state.excludedUserData.length > 0">
                <label class="col-sm col-form-label" style="white-space: normal; word-break: break-word; width: 100%; font-size: 14px;">
                  「追加のみ反映する」ボタン
                  <br>最新のユーザーから共通連絡先に反映されます。下記一覧のユーザーは削除されずに残ります。
                  <br><br>
                  「削除も反映する」ボタン
                  <br>最新のユーザーから共通連絡先に反映されます。下記一覧のユーザーは全て削除されます。
                  <br>※共通連絡先に残すユーザーは、ユーザー変更画面で「共通連絡先の対象から外す」設定を解除してください。
                </label>
              </div>
              <div class="col-12" v-else>
                <label class="col-sm col-form-label" style="white-space: normal; word-break: break-word; width: 100%; font-size: 14px;">
                  「最新のユーザーを反映する」ボタン
                  <br>最新のユーザーから共通連絡先に反映されます。
                  <br><br>
                  「削除も反映する」ボタン
                  <br>削除対象のユーザーがいないため表示されません。
                </label>
              </div> 
            </div>        
          </b-card>
        </b-collapse>
      </div>
      <div class="table-scroll">
        <table class="table table-sm table-hover form-table">
          <thead>
            <tr>
              <th scope="col" style="width:10px; border:none">#</th>
              <th scope="col" style="width:120px; border:none">連絡先名</th>
              <th scope="col" style="width:120px; border:none">所属</th>
              <th scope="col" style="width:80px; border:none">アカウント廃止日</th>
            </tr>
          </thead>
          <tbody v-if="this.$store.state.excludedUserData.length > 0">
            <tr v-for="(excludedUsers, index) in this.$store.state.excludedUserData" v-bind:key="excludedUsers.id">
              <th scope="row">{{ index + 1 }}</th>
              <td style="max-width: 120px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ excludedUsers.user.userName }}
              </td>
              <td style="max-width: 120px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                {{ excludedUsers.user.organization.organizationName }}
              </td>
              <td>{{ moment(excludedUsers.user.disableAt) }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4" class="text-center" style="padding-top: 30px; font-size: 18px;">削除対象のユーザーはいません。</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="empty-row-wide"></div>
      <div id="title" class="row" v-if="this.$store.state.excludedUserData.length > 0">
        <div class="col-12 text-center">
          <h5>操作を選択してください</h5>
        </div>
      </div>
      <div class="empty-row"></div>
      <div class="row">
        <div class="col-12 d-flex justify-content-center">
          <button id ="onlyAddBtn" type="button" class="btn btn-outline-success mr-5 mb-3" v-if="this.$store.state.excludedUserData.length > 0" v-on:click="onlyAddCommon">追加のみ反映する
            <b-tooltip target="onlyAddBtn" variant="secondary" triggers="hover">
              最新のユーザーを<br>共通連絡先に反映します。<br>上記の連絡先は削除されず<br>共通連絡先に残ります。
            </b-tooltip>
          </button>
          <button id ="removeAndAddBtn" type="button" class="btn btn-outline-warning custom-btn mb-3" v-if="this.$store.state.excludedUserData.length > 0" v-on:click="removeAndAddCommon">削除も反映する
            <b-tooltip target="removeAndAddBtn" variant="secondary" triggers="hover">
              最新のユーザーを<br>共通連絡先に反映します。<br>上記の連絡先は<br>共通連絡先およびお気に入り<br>から完全に削除されます。
            </b-tooltip>
          </button>
          <button id ="onlyAddBtn" type="button" class="btn btn-outline-success mb-3" v-if="this.$store.state.excludedUserData.length === 0" v-on:click="onlyAddCommon">最新のユーザーを反映する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../mixin/session'
import { headers } from '../mixin/headers'

export default {
  name: 'RefreshCommonContactModal',
  mixins: [sessions,headers],
  data: function(){
    return {
        message: '',
        visible: false,
    }
  },
  props: ['realms'],
  mounted() {
    this.initModal()
  },
  methods: {
    initModal(){
      this.$store.commit('excludedUserData', []); 
    },
    moment: function (date) {
      if (this.$moment(date).isValid()) {
        return this.$moment(date).format('YYYY年MM月DD日');
      } else {
        return '';
      }
    },
    closeModal(){
      this.$emit('close-modal')
    },
    removeAndAddCommon() {
      if(confirm('共通連絡先およびお気に入りから下記一覧の連絡先が全て削除されます。\nこの操作は取り消せませんがよろしいですか?')){
        //OK
        this.$cognito.isAuthenticated().then((session) => {
          if(session){
            var accessToken = this.getAccessToken(this.$cognito,session)
            var hospitalId = this.$store.getters.hospital.id
            axios.get("/api/contact/management/removeAndAdd/" + hospitalId, {
                headers: this.headers(accessToken)
            }).then(res => {
                if(res.errorMessage) {
                  this.message = res.errorMessage
                } else {
                  let addCount = res.data.data.addCount
                  let removeCount = res.data.data.removeCount
                  alert(addCount + '件 共通連絡先に追加\n' + removeCount + '件 共通連絡先から削除\n反映処理が実施されました。')
                  this.$emit('latest-id-applied')
                  this.initModal()
                  this.closeModal()
                }
            }).catch(err => {
                this.message = err.message
            })
          } else {
            this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
          }
        }).catch((err) => {
          this.message = err.message
        })
      }
    },
    onlyAddCommon() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.get("/api/contact/management/public/refresh/" + hospitalId, {
            headers: this.headers(accessToken)
          }).then(res => {
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              let addCount = res.data.data
              alert(addCount + '件 共通連絡先に追加\n反映処理が実施されました。')
              this.$emit('latest-id-applied')
              this.initModal()
              this.closeModal()
            }
          }).catch(err => {
            this.message = err.message
          })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    actionToggle: function () {
      return this.visible ? 'Arrow-Bottom' : 'Arrow-Right';
    }
  }
}
</script>

<style scoped>
#overlay {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
#content {
  width: 60%;
  padding: 1em;
  background: #fff;
}
.modal-close {
  float: right;
}
.row-margin {
  margin-bottom: 10px;
}
.table-scroll {
  position: relative;
  height: 250px;
  overflow-y: scroll;
}
.table-scroll thead tr {
  position: sticky;
  top: 0;
  background-color: #353a3f;
  color: #fff;
  border-bottom: 3px solid #ccc;
}
.table-hover tbody tr:hover {
  background-color: #fff;
}
.b-tooltip {
  max-width: 300px;
  white-space: pre-wrap;
}
#select-form {
  width: 100%;
  min-height: 35px;
}
#select-caution {
  margin-top: 5px;
  margin-left: 5px;
  margin-bottom: 0;
}
.select-item{
  display: inline;
}
.plus-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.times-solid-sm{
  cursor: pointer;
  height: 12px;
  width: 12px;
}
.Arrow-Right {
  border-right: solid 2px #0d6efd;
  border-top: solid 2px #0d6efd;
  width: 8px;
  height: 8px;
  transform: rotate(45deg);
  margin-right: 5px;
}
.Arrow-Bottom {
  border-right: solid 2px #0d6efd;
  border-top: solid 2px #0d6efd;
  width: 8px;
  height: 8px;
  transform: rotate(135deg);
  margin-right: 5px;
}
.btn.btn-outline-primary:hover .Arrow-Right,
.btn.btn-outline-primary:hover .Arrow-Bottom {
  border-color: #ffffff;
}
.custom-btn {
  background-color: #ffffff;
  border-color: #F36C21;
  color: #F36C21;
}
.custom-btn:hover {
  background-color: #F36C21;
  color: #ffffff;
}
.empty-row {
  height: 20px;
}
.empty-row-wide {
  height: 40px;
}
</style>